module.exports = __webpack_public_path__ + "img/9.af3e3293.jpg";